import React from 'react';

import users from '../../../../../images/users.svg';

const UsersIconComponent = ({ height = '14px', width = height, altText = 'icon', selected }) => {
  return <img src={users} alt={altText} style={{ width, height }} />;
};

export default UsersIconComponent;
